import { STATUS_KEYS } from '~constants/orders';

export const hasFutureActiveOrder = (activeOrders) =>
  Array.isArray(activeOrders?.page) &&
  activeOrders.page.some((order) => order.status === STATUS_KEYS.SCHEDULED);
